var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCoretimePolkadot(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_11566_37181)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.99996 19.1659C15.0617 19.1659 19.165 15.0626 19.165 10.0009C19.165 4.93925 15.0617 0.835938 9.99996 0.835938C4.93827 0.835938 0.834961 4.93925 0.834961 10.0009C0.834961 15.0626 4.93827 19.1659 9.99996 19.1659Z",
    fill: "#321D47"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.9102 10.6122C13.8382 11.2789 13.6312 11.8707 13.2893 12.3878C12.9474 12.898 12.4945 13.2959 11.9306 13.5816C11.3727 13.8605 10.7338 14 10.014 14C9.23415 14 8.5473 13.8333 7.95342 13.5C7.35955 13.1667 6.90065 12.6973 6.57672 12.0918C6.25279 11.4864 6.09082 10.7891 6.09082 10C6.09082 9.21088 6.25279 8.51361 6.57672 7.90816C6.90065 7.30272 7.35955 6.83333 7.95342 6.5C8.5473 6.16667 9.23415 6 10.014 6C10.7338 6 11.3727 6.14286 11.9306 6.42857C12.4945 6.70748 12.9474 7.10544 13.2893 7.62245C13.6312 8.13265 13.8382 8.72109 13.9102 9.38775H11.9756C11.9156 9.07483 11.7986 8.80612 11.6246 8.58163C11.4567 8.35714 11.2347 8.18707 10.9588 8.07143C10.6888 7.94898 10.3739 7.88775 10.014 7.88775C9.60607 7.88775 9.25215 7.97279 8.95221 8.14286C8.65827 8.30612 8.43032 8.54762 8.26836 8.86735C8.10639 9.18707 8.02541 9.56463 8.02541 10C8.02541 10.4354 8.10639 10.8129 8.26836 11.1327C8.43032 11.4524 8.65827 11.6973 8.95221 11.8673C9.25215 12.0306 9.60607 12.1122 10.014 12.1122C10.3739 12.1122 10.6888 12.0578 10.9588 11.949C11.2347 11.8333 11.4567 11.6633 11.6246 11.4388C11.7986 11.2075 11.9156 10.932 11.9756 10.6122H13.9102Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.4173 3.7007C11.4173 4.48357 10.7826 5.1182 9.99978 5.1182C9.21692 5.1182 8.58228 4.48357 8.58228 3.7007C8.58228 2.91784 9.21692 2.2832 9.99978 2.2832C10.7826 2.2832 11.4173 2.91784 11.4173 3.7007Z",
    fill: "#E40B7B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.4173 16.3007C11.4173 17.0836 10.7826 17.7182 9.99978 17.7182C9.21692 17.7182 8.58228 17.0836 8.58228 16.3007C8.58228 15.5178 9.21692 14.8832 9.99978 14.8832C10.7826 14.8832 11.4173 15.5178 11.4173 16.3007Z",
    fill: "#E40B7B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.1644 8.0787C15.4864 8.47014 14.6195 8.23784 14.228 7.55986C13.8366 6.88188 14.0689 6.01495 14.7469 5.62352C15.4249 5.23209 16.2918 5.46438 16.6832 6.14236C17.0747 6.82034 16.8424 7.68727 16.1644 8.0787Z",
    fill: "#E40B7B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.25247 14.3787C4.57449 14.7701 3.70756 14.5378 3.31613 13.8599C2.92469 13.1819 3.15699 12.315 3.83497 11.9235C4.51295 11.5321 5.37988 11.7644 5.77131 12.4424C6.16274 13.1203 5.93045 13.9873 5.25247 14.3787Z",
    fill: "#E40B7B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.83496 8.0787C4.51294 8.47013 5.37987 8.23784 5.7713 7.55986C6.16274 6.88188 5.93044 6.01495 5.25246 5.62352C4.57448 5.23208 3.70755 5.46438 3.31612 6.14236C2.92469 6.82034 3.15698 7.68727 3.83496 8.0787Z",
    fill: "#E40B7B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.7469 14.3787C15.4249 14.7701 16.2918 14.5378 16.6832 13.8599C17.0747 13.1819 16.8424 12.3149 16.1644 11.9235C15.4864 11.5321 14.6195 11.7644 14.228 12.4424C13.8366 13.1203 14.0689 13.9873 14.7469 14.3787Z",
    fill: "#E40B7B"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_11566_37181"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCoretimePolkadot);
export default __webpack_public_path__ + "static/media/coretime-polkadot.87e3691566777738fdd2164feff73837.svg";
export { ForwardRef as ReactComponent };